import {ChangeEvent} from "react";
import {DropdownOption, DropdownProps} from "react-day-picker";

import {Select} from "@/components/select/Select.tsx";

export const DatePickerSelect = ({
  options,
  value,
  onChange,
  className,
  variant = "datepicker",
}: Omit<DropdownProps, "size" | "defaultValue" | "onBlur" | "onFocus" | "onKeyDown" | "classNames" | "variant"> & {
  variant?: "datepicker" | "datepickerMonths";
}) => {
  return (
    <Select<DropdownOption, false>
      async={false}
      variant={variant}
      options={options}
      value={options?.find((option) => option.value === value)}
      onChange={(option) => {
        onChange?.({
          target: {
            value: option?.value.toString() ?? "",
          },
        } as ChangeEvent<HTMLSelectElement>);
      }}
      getOptionValue={(option) => option.value.toString()}
      getOptionLabel={(option) => option.label}
      className={className}
    />
  );
};
